import React, { useEffect, useState } from "react";
import apiFetch from "@wordpress/api-fetch";

export const DocumentFolder = ({folderId, secretFolder}) => {

    const [files, setFiles] = useState([]);

        useEffect(() => {
            loadData();
        }, [folderId])

        const loadData = async () => {
            const files = await useDocuments(folderId);
            
            setFiles(files);
        }

    return (
        <>
            {files.map(file => (
                <>
                    <p>
                        {secretFolder ? (
                            <a href={`https://is.mendelu.cz/auth/dok_server/slozka.pl?id=${folderId};download=${file.id}`} target="_blank">
                                {file.name}
                            </a>
                        ) : (
                            <a href={`https://is.mendelu.cz/dok_server/slozka.pl?id=${folderId};download=${file.id}`} target="_blank">
                                {file.name}
                            </a>
                        )}
                    </p>
                </>
            ))}
        </>
    );
}

const useDocuments = async (id) => {
    const response = await apiFetch({
        path: `/mendelu/v1/document/folder/${id}`,
    });

    return response
}